import { combineReducers } from "redux";
import prompt from "./snackbar/reducer";
import loader from "./loader/reducer";
import authReducer from "./common/reducer";
import menuReducer from "./menu/reducer";

const rootReducer = combineReducers({
  snackbar: prompt,
  loader: loader,
  authReducer: authReducer,
  menuReducer: menuReducer,
});

export default rootReducer;
